<template>
    <div>
        <div class="nav-vertical">
            <ul class="nav nav-tabs nav-left" role="tablist">
                <li class="nav-item">
                    <a class="nav-link active" v-bind:href="'#t1' + rowData.id + ''" role="tab" data-toggle="tab">
                        <span class="nav-link-in">
                            Logs
                            <i class="fa fa-bulding"></i>
                        </span>
                    </a>
                </li>
            </ul>

            <div class="tab-content">
                <div 
                role="tabpanel" 
                class="tab-pane fade in active show pt-1 border-color-detalhes-grey"
                v-bind:id="'t1' + rowData.id + ''">
                    <table class="table-striped" id="mais">
                        <thead>
                            <tr>
                                <th width="5%">ID Log</th>
                                <th width="15%">Descrição</th>
                                <th width="10%">Codigo de Barras</th>
                                <th width="10%">Usuário</th>
                                <th width="5%">Data</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="bg-gray-light" style="display: table-row;"
                                v-for="item in rowData.doc_fiscal_volume.doc_fiscal_volume_log">
                                <td>
                                    {{ item.docfisvollog_id }}
                                </td>
                                <td>
                                    {{ item.descr }}
                                </td>
                                <td>
                                    {{ item.cd_barra }}
                                </td>
                                <td>
                                    <span class="label label-primary">{{ item.usuario_inc.email }}</span>
                                </td>
                                <td>
                                    {{ parseDatetime(item.dt_inc) }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import {formatToBrazilianDate} from '../utils';

export default {
    data() {
        return {
            helpForm: new Form({ permissionRole: [], params: [] }),
        }
    },
    props: {
        rowData: {
            type: Object,
            required: true
        },
        rowIndex: {
            type: Number
        }
    },
    methods: {
        parseDatetime(data) {
            return formatToBrazilianDate(data);
        }
    }
}
</script>
